import React from 'react';
import { Link } from 'react-router';
import { ListItem } from 'material-ui/List';

import ContextIconMenu from '../Common/ContextIconMenu';
import IconButton from 'material-ui/IconButton';
import InfoIcon from 'material-ui/svg-icons/action/info';
import EditIcon from 'material-ui/svg-icons/editor/mode-edit';
import MoreVertIcon from 'material-ui/svg-icons/navigation/more-vert';

import LinearProgress from 'material-ui/LinearProgress';

import { statusColours } from '../../constants/ColourConstants';

import SkillIcon from 'material-ui/svg-icons/social/public';
import TrainerIcon from 'material-ui/svg-icons/editor/title';
import CertificateIcon from 'material-ui/svg-icons/action/verified-user';


import SkillActions from '../../actions/SkillActionCreator';

import ROLES from '../../constants/Roles';
import { DateStyles } from '../../constants/CentricConstants';


const style = {
    menu: {
        marginRight: 0,
        marginBottom: 0,
        float: 'left',
        position: 'relative',
        zIndex: 0,
    },
    menuItem: {
        color: '#CC0000',
    },
    iconButton: {
        marginRight: 0,
    },
    listItem: {
        padding: '2px',
    },
    icon: {
        height: '32px',
        width: '32px',
    }
};


const getActions = (row) => [
    {
        link: `/dashboard/skill/${row.id}`,
        label: 'Preview',
        icon: <InfoIcon />
    },
    {
        type:'divider'
    },
    {
        link: `/dashboard/skill/${row.id}/edit`,
        label: 'Edit',
        icon: <EditIcon />,
        condition: {
            roles: [ROLES.ADMIN]
        }
    },
    {
        type: 'deleteDialog',
        dialogType: 'menu',
        value: row.id,
        title: 'Delete skill',
        deleteAction: SkillActions.delete,
        message: (
            <span> Are you sure to delete the skill  "{row.name}" ?</span>
        ),
        condition: {
            roles: [ROLES.ADMIN],
            show: !!row.canBeDeleted
        }
    }
];

const SkillListItem  = ({data, actions}) => {

    const infoLink = '/dashboard/skill/' + data.id;
    const today = new Date();
    const validFrom = new Date(data.validFrom);
    const validTo = new Date(data.validTo);

    let description = '';

    let iconGroup = [];
    if (!!data.trainer) {
        iconGroup.push(<TrainerIcon className="icon-small" key="trainer" />);
    }

    if (data.certificateId) {
        iconGroup.push(<CertificateIcon className="icon-small" key="certificate" />);
    }

    let isActive =  (today >= validFrom);

    if (!!data.validTo) {

        if (today > validTo) {
            isActive =  false;
            description = (<span>Unavailable</span>);
        } else {
            description = (<span>Available until {validTo.toLocaleString('en-GB', DateStyles.short)}</span>);
        }
    } else {
        description = (<span>Available from {validFrom.toLocaleString('en-GB', DateStyles.short)}</span>);
    }

    const actionList = (actions || getActions(data));

    let listItemProps = {
            key: data.id,
            style: style.listItem,
            primaryText: <Link to={infoLink} className="primaryText">{data.name} ({data.code})</Link>
    };


    if (data.loading) {
            listItemProps.secondaryText = <div><LinearProgress mode="indeterminate"/></div>;
            } else if (data.secondaryText) {
            listItemProps.secondaryText = <Link to={infoLink} className="secondaryText">{data.secondaryText}</Link>;
            listItemProps.secondaryTextLines = (data.secondaryTextLines || 2);
            } else {
            listItemProps.secondaryText = <Link to={infoLink} className="secondaryText">
                <em>{description}</em>
                <br />
                {iconGroup}{data.level}
            </Link>;
            listItemProps.secondaryTextLines = 2 ;
    }

    if (!!actionList && actionList.length > 0) {
            const topRight = {horizontal: 'right', vertical: 'top'};
            const iconMenuProps = {
                actions: actionList,
                data: data,
                menuStyle: style.menu,
                anchorOrigin: topRight,
                targetOrigin: topRight,
            };

            listItemProps.rightIcon = <ContextIconMenu {...iconMenuProps}
                iconButtonElement={
                    <IconButton touch={true} style={style.iconButton} >
                        <MoreVertIcon color={statusColours.light} />
                    </IconButton>
                }
            />
    }

     return (
            <ListItem {...listItemProps}
                leftAvatar={
                    <Link to={`/dashboard/skill/${data.id}`} >
                        <SkillIcon style={style.icon} color={isActive ? statusColours.primary : statusColours.disabled} />
                    </Link>
                }
            />
      )

};

export default SkillListItem;
